import React from 'react';
import LoadingDots from '../LoadingDots';
import css from './insights.less';

export default function TripDayTable({
                                         data
                                     }: any) {
    return (
        <table className="index-table no-links">
            <thead>
                <tr>
                    {/* @ts-expect-error ts-migrate(2322) FIXME: Property 'width' does not exist on type 'DetailedH... Remove this comment to see the full error message */}
                    <th width={40}>#</th>
                    {/* @ts-expect-error ts-migrate(2322) FIXME: Property 'width' does not exist on type 'DetailedH... Remove this comment to see the full error message */}
                    <th width={110}>Day</th>
                    {/* @ts-expect-error ts-migrate(2322) FIXME: Property 'width' does not exist on type 'DetailedH... Remove this comment to see the full error message */}
                    <th width={80}>Bookings</th>
                    <th>%</th>
                </tr>
            </thead>
            <tbody>
                {data ? data.map((row: any) => <tr key={row.dowNumber}>
                    <td>{row.dowNumber}</td>
                    <td><span className={css.colorKey} style={{backgroundColor: row.color}}/>{row.dowName}</td>
                    <td>{row.countFormat}</td>
                    <td>{row.percentage}</td>
                </tr>) : <tr>
                    <td colSpan={4}><LoadingDots center/></td>
                </tr>}
            </tbody>
        </table>
    );
}
